// extracted by mini-css-extract-plugin
export default {"custom-slider":"CustomCourseSlider_custom-slider__EPRTD","slider-desc":"CustomCourseSlider_slider-desc__RfXJO","view-all":"CustomCourseSlider_view-all__Z6mT+"};